export const colors = {
    whitesmoke: '#f5f5f5',
    white: '#ffffff',
    black: '#000000',
    lightGray: '#0000008a',
}